import { render, staticRenderFns } from "./ProofwrkReport.vue?vue&type=template&id=c410163c"
import script from "./ProofwrkReport.vue?vue&type=script&lang=js"
export * from "./ProofwrkReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports